import {Component, Inject, OnInit} from '@angular/core';
import {AppService} from "../../utils/app.service";
import {TransitionService} from '@uirouter/core';

@Component({
    selector: 'body',
    template: `<ui-view></ui-view>`
})

export class AppComponent implements OnInit{
    constructor(
        @Inject(AppService) public app,
        private transitionService: TransitionService
    ) {

    }
    ngOnInit(){
        if (this.transitionService ) {
            let transions =  this.transitionService;
            transions.onSuccess({}, (transition) => {
                this.app.refreshPageData(transition.to());
            });
            transions.onStart({}, (transition) => {
                this.app.refreshPageData(transition.to());
            });
        }
    }
}
